import MainWrapper from './MainWrapper';

export default MainWrapper;
